import React from 'react';

const API_ORIGIN = process.env.NODE_ENV === 'production'
  ? ''
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1').replace(/\/api\/v1$/, '');

const ImagemPergunta = ({ imagemPath }) => {
  if (!imagemPath) return null;

  return (
    <img
      src={`${API_ORIGIN}${imagemPath}`}
      alt=""
      className="w-full max-h-64 object-cover rounded-lg mb-4"
    />
  );
};

export default ImagemPergunta;
